/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days } from "../../funcs/metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations
    .GetApiV3MetricsMaxTransactionsPerSecOver90DaysRequest$inboundSchema
    .optional(),
};

export const tool$metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days:
  ToolDefinition<typeof args> = {
    name: "metrics-get-api-v3-metrics-max-transactions-per-sec-over-90-days",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await metricsGetApiV3MetricsMaxTransactionsPerSecOver90Days(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
